/******************************************************************/
/*                    POLUKER Specific Processes                  */
/******************************************************************/

import { ObjectId } from '@jurinfor/typing';
import { recFormReaction } from '@jurinfor/game-process';
import { SetSubjectState, Option, Seq, OnlyWhen, Message, Pass } from '@jurinfor/game-process/processes';
import LambdaLib from '@jurinfor/game-process/lambda';

const { reduceLambdaObject, Lambda, Var, External, evaluate } = LambdaLib;

export const setHintSemantic = {
  exc(process, state) {
    let msg = process.msg;
    if (msg.type === "Lambda") {
      msg = reduceLambdaObject(msg, configProcess.lambda.reduction);
    }
    if (msg.type === "StatefulExpr") {
      msg = evaluate(msg.term, state, configProcess.lambda.reduction, "State");
    }
    const fr = recFormReaction(state)(SetSubjectState(process.subj, new Lambda(new Var(), new External({ hasNewHint: true }, "Object"))));
    return {
      form: fr.form,
      reaction: function(v) {
        var r = fr.reaction(v);
        r = {
          ...r,
          istate: {
            ...r.istate,
            curHint: {
              ...(r.istate.curHint || {}),
              [process.subj]: msg, // r.istate.curHint[process.subj]
            }
          }
        };
        return r;
      }
    };
  },

  trmap(p, t) {
    return p;
  },

  lmap(p, f) {
    if (p.msg.type == "Lambda") {
      return { type: "setHint", msg: { type: "Lambda", term: f(p.msg.term) }, subj: p.subj };
    }
    if (p.msg.type == "StatefulExpr") {
      return { type: "setHint", msg: { type: "StatefulExpr", term: f(p.msg.term) }, subj: p.subj };
    }
    return p;
  },

  cln(p) {
    return p;
  },

  tp: ObjectId,
};


export const HintSemantic = {
  exc(process, state) {
    if (state.objects?.curHint?.[process.subj] !== undefined) {
      const proc = Seq([
        Option({ subj: process.subj, caption: "Получить подсказку" }),
        SetSubjectState(process.subj, new Lambda(new Var(), new External({ hasNewHint: false }, "Object"))),
        Message(state.istate.curHint[process.subj], process.subj),
        Pass.changeState(External({
          func: "istate => Object.assign({}, istate, {curHint: undefined})",
          codObjType: "Object",
        }, "Function")),
		    {
		      type: "Lambda",
		      term: External(process, "Process"),
		    }
		  ]);
		  return recFormReaction(state)(proc);
    }
    const alwaysFalse = new Lambda(new Var(), new External(false, "Boolean"));
    return recFormReaction(state)(OnlyWhen(alwaysFalse, Option({ subj: process.subj, caption: "Нет новых подсказок" })));
  },

  trmap(p, t) {
    return p;
  },

  lmap(p, f) {
    return p;
  },

  cln(p) {
    return p;
  },

  tp: ObjectId,
};
